var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionHangout = function SvgIcnMintOptionHangout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    fill: "#E7EFFF",
    stroke: "#23314A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22 13.845v-5.67h1.199v2.34h2.434v-2.34h1.196v5.67h-1.196v-2.342H8.419v2.342h-1.2ZM14.104 16.38h-2.01v-5.671h2.026c.57 0 1.062.113 1.473.34.412.225.729.55.95.972.224.423.335.929.335 1.517 0 .591-.111 1.099-.335 1.524-.221.424-.54.75-.955.977-.414.227-.908.34-1.484.34Zm-.812-1.028h.762c.354 0 .652-.063.894-.188.244-.127.427-.324.548-.59.124-.268.186-.613.186-1.036 0-.419-.062-.761-.186-1.027a1.202 1.202 0 0 0-.545-.587c-.242-.125-.54-.188-.894-.188h-.765v3.616Z",
    fill: "#23314A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.088 4.78h-.098v14.524h.098V4.78Z",
    fill: "#23314A"
  })));
};
export default SvgIcnMintOptionHangout;